<template>
    <div>
        <v-flex 
            v-for="(formItem, indexF) in CustomForm"
            :key="'form'+indexF"
            :class="formItem.layout"
        >
            <!-- Normal Input -->
            <v-text-field
                v-if="formItem.inputType.code == 'STRING'"
                v-show="checkVisibilityRules(formItem)"
                v-model="formItem.value"
                v-validate="checkValidatation(formItem)"

                :label="checkPlaceholderWithRequire(formItem)"
                :error-messages="errors.collect(formItem.name)"
                :data-vv-name="formItem.name"
                :data-vv-delay="1000"
            />

            <!-- Number Input -->
            <v-text-field
                v-if="formItem.inputType.code == 'INTEGER'"
                v-show="checkVisibilityRules(formItem)"
                v-model.number="formItem.value"
                v-validate="checkValidatation(formItem)"
                :label="checkPlaceholderWithRequire(formItem)"
                :type="'number'"
                :min="formItem.minValue"
                    
                :max="formItem.maxValue"
                :error-messages="errors.collect(formItem.name)"
                :data-vv-name="formItem.name"
                :data-vv-delay="1000"
            />

            <!-- Float Input -->
            <v-text-field
                v-if="formItem.inputType.code == 'FLOAT'"
                v-show="checkVisibilityRules(formItem)"
                v-model.number="formItem.value"
                v-validate="checkValidatation(formItem)"
                :label="checkPlaceholderWithRequire(formItem)"
                    
                :type="'number'"
                :error-messages="errors.collect(formItem.name)"
                :data-vv-name="formItem.name"
                :data-vv-delay="1000"
            />

            <!-- Text Area Input -->
            <v-textarea
                v-if="formItem.inputType.code == 'TEXTAREA'"
                v-show="checkVisibilityRules(formItem)"
                v-model.number="formItem.value"
                v-validate="checkValidatation(formItem)"

                :label="checkPlaceholderWithRequire(formItem)"
                :error-messages="errors.collect(formItem.name)"
                :data-vv-name="formItem.name"
                :data-vv-delay="1000"
            />

            <!-- Select Input -->
            <v-autocomplete
                v-if="formItem.inputType.code == 'DROPDOWN'"
                v-show="checkVisibilityRules(formItem)"
                v-model="formItem.value"
                v-validate="checkValidatation(formItem)"
                :items="getPossibleValues(formItem.possibleValues)"

                :label="checkPlaceholderWithRequire(formItem)"
                :error-messages="errors.collect(formItem.name)"
                :data-vv-name="formItem.name"
            />

            <!-- Switch Input -->
            <v-switch
                v-if="formItem.inputType.code == 'switch'"
                v-show="checkVisibilityRules(formItem)"
                v-model="formItem.value"
                :label="checkPlaceholderWithRequire(formItem)"
            />

            <!-- Checkbox Input -->
            <v-select
                v-if="formItem.inputType.code == 'CHECKBOX'"
                v-model="formItem.value"
                v-validate="checkValidatation(formItem)"
                :items="getPossibleValues(formItem.possibleValues)"
                :label="checkPlaceholderWithRequire(formItem)"

                multiple
                :error-messages="errors.collect(formItem.name)"
                :data-vv-name="formItem.name"
            />

            <!-- Radio Input -->
            <v-radio-group v-if="formItem.inputType.code == 'radio'" v-model="formItem.value">
                <v-radio
                    v-for="option in formItem.options"
                    v-show="checkVisibilityRules(formItem)"
                    :key="option"
                    :label="checkPlaceholderWithRequire(formItem)"
                    :value="option"
                />
            </v-radio-group>

            <!-- ComboBox Input -->
            <v-combobox
                v-if="formItem.inputType.code == 'combobox'"
                v-show="checkVisibilityRules(formItem)" 
                v-model="formItem.value" 
                :items="formItem.options"
                :label="checkPlaceholderWithRequire(formItem)" 
                item-text="name" 
                item-value="id" 
                chips 
                clearable 
                multiple 
                :hide-details="true"
            >
                <template slot="selection" slot-scope="data">
                    <v-chip 
                        :selected="data.selected" 
                        close 
                        @input="remove(data.item, index)"
                    >
                        <strong>{{ data.item.name }}</strong>&nbsp;
                    </v-chip>
                </template>
            </v-combobox>

            <!-- Datetime Input -->
            <el-date-picker
                v-if="formItem.inputType.code == 'DATETIME'"
                v-model="formItem.value"
                class="dateTime-input"
                type="datetime"
                placeholder="Select date and time"
            />

            <!-- Calendar Input -->
            <v-menu v-if="formItem.inputType.code == 'DATE'"
                    v-model="formItem.isCalendarDialog"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
            >
                <v-text-field
                    v-show="checkVisibilityRules(formItem)"
                    slot="activator"
                    v-model="formItem.value"
                    v-validate="checkValidatation(formItem)"
                    :label="checkPlaceholderWithRequire(formItem)"

                    readonly
                    :error-messages="errors.collect(formItem.name)"
                    :data-vv-name="formItem.name"
                />
                <v-date-picker v-model="formItem.value" @input="formItem.isCalendarDialog = false" />
            </v-menu>

            <!-- Time Input -->
            <v-menu v-if="formItem.inputType.code == 'TIME'"
                    v-model="formItem.isClockDialog"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
            >
                <v-text-field
                    v-show="checkVisibilityRules(formItem)"
                    slot="activator"
                    v-model="formItem.value"
                    v-validate="checkValidatation(formItem)"
                    :label="checkPlaceholderWithRequire(formItem)"

                    readonly
                    :error-messages="errors.collect(formItem.name)"
                    :data-vv-name="formItem.name"
                />
                <v-time-picker v-model="formItem.value" @input="formItem.isClockDialog = false" />
            </v-menu>
                
            <!-- Media File -->
            <div v-if="formItem.inputType.code == 'PHOTOS' || formItem.inputType.code == 'SIGNATURE' || formItem.inputType.code == 'VIDEOS' || formItem.inputType.code == 'AUDIO'" class="media-div">
                <b-form-file
                    v-model="formItem.value"
                    v-validate="checkValidatation(formItem)"
                    :name="formItem.name"
                    :placeholder="checkPlaceholderWithRequire(formItem)"

                    :accept="checkAcceptFormat(formItem.inputType.code)"
                />
                <span v-show="errors.has(formItem.name)" class="is-danger-warning">{{ errors.first(formItem.name) }}</span>
            </div>

            <!-- Label -->
            <div v-if="formItem.inputType.code == 'label'">{{ formItem.name }}</div>

            <!-- Empty Space -->
            <div v-if="formItem.inputType.code == 'space'" :style="`height: ${formItem.height}`" />

            <!-- Section Line -->
            <div v-if="formItem.inputType.code == 'SECTION'">
                <p class="section-title">{{ formItem.name }}</p>
            </div>

            <!-- Children Custom Field -->
            <div v-if="formItem.childrenCustomFields.length > 0" class="children-group">
                <dynamic-form ref="groupDynamicForm" :dynamic-form="formItem.childrenCustomFields" :is-group-dynamic-form="true" @receiveGroupCustomField="receiveGroupCustomField()" />
            </div>
        </v-flex>
            

        <!-- Save Dialog -->
        <general-dialog :dialog.sync="isConfirmDialog" :header="header">
            <template #header>
                <h4>Are you sure</h4>
            </template>
            <template #content>
                Are you sure to save this?
            </template>
            <template #action>
                <v-btn color="agrinome_primary" dark @click="arrangeCustomData()">Save</v-btn>
            </template>
        </general-dialog>
    </div>
</template>

<script>
import { TokenService } from "@/services/storage.service";

export default {
    name: "DynamicForm",
    props: ["DynamicForm", "fieldDataFormId", "SelectedPalm", "isGroupDynamicForm", "dateTimeValue"],
    data() {
        return {
            comparatorTypeOpts: [],
            selected: [],

            // groupDynamicLength: 0,

            isConfirmDialog: false,
            header: "Are you sure?"
        };
    },
    computed: {
        CustomForm() {
            return this.DynamicForm.map(item => {
                if (item.inputType.code === "CHECKBOX") {
                    item.value = [];
                }
                else if (item.defaultValue) {
                    item.value = item.defaultValue;
                }
                else item.value = null;

                return item;
            });
        }
    },
    mounted() {
    },
    methods: {
        checkAcceptFormat(inputType) {
            switch (inputType) {
            case "PHOTOS":
                return "image/*";
                break;
            case "SIGNATURES":
                return "image/*";
                break;
            case "VIDEOS":
                return "video/mp4,video/x-m4v,video/*";
                break;
            case "AUDIOS":
                return "audio/*";
                break;
            default:
                return "*";
                break;
            }
        },
        getPossibleValues(values) {
            var options = values.split(",");
            return options.map(opt => opt.trim());
        },
        comparatorCodeSwitchCase(comparatorCode, targetFieldValue, rule) {
            var validation = [];
            switch (comparatorCode) {
            case "CONTAINS":
                validation.push(targetFieldValue.includes(rule.value));
                break;
            case "ENDS_WITH":
                validation.push(targetFieldValue.endsWith(rule.value));
                break;
            case "EQUAL_TO":
                validation.push(targetFieldValue == rule.value);
                break;
            case "GREATER_THAN":
                validation.push(targetFieldValue > rule.value);
                break;
            case "GREATER_THAN_OR_EQUAL_TO":
                validation.push(targetFieldValue >= rule.value);
                break;
            case "LESSER_THAN":
                validation.push(targetFieldValue < rule.value);
                break;
            case "LESSER_THAN_OR_EQUAL_TO":
                validation.push(targetFieldValue <= rule.value);
                break;
            case "NOT_EQUAL_TO":
                validation.push(targetFieldValue != rule.value);
                break;
            case "STARTS_WITH":
                validation.push(targetFieldValue.startsWith(rule.value));
                break;
            default:
                break;
            }
            return validation;
        },
        checkVisibilityRules(item) {
            var visibilityValidation = [];
            if (item.customFieldVisibilityRules) {
                item.customFieldVisibilityRules.forEach(rule => {
                    var comparatorCode = (rule.comparatorType || {}).code;
                    var targetField = this.CustomForm.filter(field => field.id == rule.customFieldId);
                        
                    var targetFieldValue = targetField[0].value;

                    if (targetFieldValue) {
                        visibilityValidation = this.comparatorCodeSwitchCase(comparatorCode, targetFieldValue, rule);
                        console.log(visibilityValidation);
                    }
                    else visibilityValidation.push(false);
                });
            }

            if (visibilityValidation.length > 1) {
                if (item.visibilityMatchCondition == "All") return (visibilityValidation.includes(false) && visibilityValidation.includes(true));
                else return (visibilityValidation.includes(false) || visibilityValidation.includes(true));
            }
            else if ( visibilityValidation.length == 1 ) {
                if (visibilityValidation.includes(false)) return false;
                else return true;
            }
            else return true;
        },
        checkValidatation(item) {
            var validation = "";
            item.isRequired === true ? validation = `${validation}${this.checkIsPipeline(validation)}required: true` : ""; 
            item.minLength !== null ? validation = `${validation}${this.checkIsPipeline(validation)}min: ${item.minLength}` : "";
            item.maxLength !== null ? validation = `${validation}${this.checkIsPipeline(validation)}max: ${item.maxLength}` : "";
            item.minValue !== null ? validation = `${validation}${this.checkIsPipeline(validation)}min_value: ${item.minValue}` : "";
            item.maxValue !== null ? validation = `${validation}${this.checkIsPipeline(validation)}max_value: ${item.maxValue}` : "";

            if (item.customFieldRequirementRules) {
                if (item.customFieldRequirementRules.length > 0) {
                    var requirementValidation = [];
                    item.customFieldRequirementRules.forEach(rule => {
                        var comparatorCode = (rule.comparatorType || {}).code;
                        var targetField = this.CustomForm.filter(field => field.id == rule.customFieldId);
                        var targetFieldValue = targetField[0].value;

                        if (targetFieldValue) {
                            requirementValidation = this.comparatorCodeSwitchCase(comparatorCode, targetFieldValue, rule);
                        }
                        else requirementValidation.push(false);
                    });
                        
                    if (checkRequirement()) {
                        item.isRequired = true;
                        validation = `${validation}${this.checkIsPipeline(validation)}required: true`;
                    }
                    else {
                        item.isRequired = false;
                        validation = "";
                    }

                    function checkRequirement () {
                        if (requirementValidation.length > 1) {
                            if (item.requirementMatchCondition == "All") return (requirementValidation.includes(false) && requirementValidation.includes(true));
                            else return (requirementValidation.includes(false) || requirementValidation.includes(true));
                        }
                        else if ( requirementValidation.length == 1 ) {
                            if (requirementValidation.includes(false)) return false;
                            else return true;
                        }
                        else return true;
                    }
                }
            }

            return validation;
        },
        checkIsPipeline(string) {
            if (string.length > 0) return "|";
            else return "";
        },
        checkPlaceholderWithRequire(item) {
            var name = item.measurementUnitId ? item.name + " / " + item.measurementUnit.name : item.name;
            name = item.isRequired ? name + "*" : name;
            return name;
        },
        cleanValue() {
            this.DynamicForm.forEach(item => {
                if (item.inputType.code === "CHECKBOX") {
                    item.value = [];
                }
                else if (item.defaultValue) {
                    item.value = item.defaultValue;
                }
                else item.value = null;
            });
            this.$emit("remove-palm");
            this.$forceUpdate();
        },
        validateField() {
            var self = this;
            this.$validator.validateAll().then( result => {
                if (result) {
                    if (self.$refs.groupDynamicForm) {
                        self.$refs.groupDynamicForm.forEach((form, index) => {
                            form.validateGroupField(index + 1, self.$refs.groupDynamicForm.length);
                        });
                    }
                    else {
                        self.isConfirmDialog = true;
                    }
                }
            });
        },
        validateGroupField(number, length) {
            var self = this;
            self.$validator.validateAll().then( result => {
                if ( result ) {
                    if ( number && length == number ) {
                        self.isConfirmDialog = true;
                    }
                    else if ( number && length != number ) {
                        self.isConfirmDialog = false;
                    }
                    else {
                        self.isConfirmDialog = true;
                    }
                }
            });
        },
        async receiveGroupCustomField(e) {
            function CustomField(item) {
                this.customFieldId = item.id;
                this.name = item.name;
                this.value = item.value;
            }

            var _CustomForm = JSON.parse(JSON.stringify(this.CustomForm));
            var customFieldDataList = await _CustomForm.map(item => {
                if (item.childrenCustomFields.length > 0) {
                    return item.childrenCustomFields.map(groupItem => {
                        return { ...new CustomField(groupItem) };
                    });
                }
                return { ...new CustomField(item) };
            });

            var flattenedCustomFieldDataList = [].concat.apply([],customFieldDataList);
            this.confirmSave(flattenedCustomFieldDataList);
        },
        async arrangeCustomData() {
            if (this.isGroupDynamicForm) {
                this.$emit("receiveGroupCustomField");
            }
            else {
                this.receiveGroupCustomField();
            }
            this.isConfirmDialog = false;
        },
        confirmSave(customFieldDataList) {
            var AuthInfo = TokenService.getAuthInfo();
            var self = this;
            axios({
                method: "POST",
                url: "PalmRecording/CreateFieldDataFormRecording",
                data: {
                    "fieldDataFormId": self.fieldDataFormId,
                    "palmId": self.SelectedPalm, 
                    "recordingDate": moment(self.dateTimeValue).format(),
                    "recordingUserId": AuthInfo.userId,
                    "customFieldExtensionDataList": customFieldDataList
                }
            })
                .then(function (response) {
                    EventBus.$emit("snackBar", {
                        text: "Form Submitted",
                        snackbarColor: "green"
                    });
                    self.cleanValue();
                });
        }
    }
};
</script>

<style lang="css" scoped>
.section-title{
    margin: 16px 0;
    font-size: 16px;
    color: #757575;
    font-weight: 700;
    padding-bottom: 8px;
    border-bottom: 1px solid #eeeeee;
}
.checkbox-label {
    margin: 24px 0 8px 0;
    font-size: 16px;
    color: #757575;
    font-weight: 700;
}
.checkbox-selection{
    margin: 0;
}
.children-group{
    padding: 0 0 0 16px;
}
.is-danger-warning{
    display: block;
    font-size: 12px;
    color: #f44336;
    margin: 0;
    font-family: Roboto,sans-serif;
    margin-top: 4px
}
.media-div{
    margin: 10px 0;
    padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/smallComponents/DynamicForm.vue